import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito mucha inversión inicial?',
  a: 'No. El plan enseña a empezar con lo mínimo y reinvertir.'
}, {
  q: '¿Es difícil si no sé nada de té?',
  a: 'Para nada, tienes 250 recetas paso a paso.'
}, {
  q: '¿El acceso es para siempre?',
  a: 'Sí, el pago es único y el material es tuyo de por vida.'
}, {
  q: '¿Funciona en mi país?',
  a: 'Incluimos una lista de proveedores verificada para toda la región (Norteamérica, Centroamérica, Sudamérica y España).'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 px-6 lg:px-8 bg-white" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <FadeIn data-id="element-97">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-tea-green text-center mb-12" data-id="element-98">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-99">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-100">
              <div className="border border-tea-sage/60 rounded-xl overflow-hidden bg-tea-cream/30" data-id="element-101">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-102">
                  <span className="font-bold text-tea-green text-lg pr-8" data-id="element-103">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-tea-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-104" />
                </button>

                <AnimatePresence data-id="element-105">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-106">
                      <div className="px-6 pb-5 pt-0 text-tea-charcoal/80 leading-relaxed" data-id="element-107">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}